<script setup lang="ts">
import type { InputProps } from '@fondof-ui/components/input/types'
import { useVModel } from '@vueuse/core'

const props = defineProps<InputProps>()

const emits = defineEmits<{
  'update:modelValue': [payload: string | number]
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  ...props,
})
</script>

<template>
  <input
    v-model="modelValue"
    :class="props.class"
    :type="props.type"
  />
</template>
